import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const OrangeInBlueMasked = ({
  svgProps,
  hideGrain,
}: {
  svgProps: React.SVGProps<SVGSVGElement>
  hideGrain?: boolean
}) => {
  const uniqueId = useId()
  const maskId = `grainMask-orange-in-blue-masked-${uniqueId}`

  return (
    <svg
      {...svgProps}
      width="1440"
      height="1644"
      viewBox="0 0 1440 1644"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id={`filter0_f_6277_2314_${uniqueId}`}
          x="36.0647"
          y="409.368"
          width="1246.2"
          height="1185.74"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_6277_2314"
          />
        </filter>
        <filter
          id={`filter1_f_6277_2314_${uniqueId}`}
          x="81.5724"
          y="101.467"
          width="1293.79"
          height="1193.79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="175.237"
            result="effect1_foregroundBlur_6277_2314"
          />
        </filter>

        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter={`url(#filter0_f_6277_2314_${uniqueId})`}>
            <ellipse
              cx="659.165"
              cy="1002.24"
              rx="318.23"
              ry="312.83"
              transform="rotate(-30.7308 659.165 1002.24)"
              fill="white"
            />
          </g>
          <g opacity="0.7" filter={`url(#filter1_f_6277_2314_${uniqueId})`}>
            <circle
              cx="728.468"
              cy="698.363"
              r="296.375"
              transform="rotate(-33.0533 728.468 698.363)"
              fill="white"
            />
          </g>
        </mask>
      </defs>

      <g filter={`url(#filter0_f_6277_2314_${uniqueId})`}>
        <ellipse
          cx="659.165"
          cy="1002.24"
          rx="318.23"
          ry="312.83"
          transform="rotate(-30.7308 659.165 1002.24)"
          fill="#176BE5"
        />
      </g>

      <g opacity="0.7" filter={`url(#filter1_f_6277_2314_${uniqueId})`}>
        <circle
          cx="728.468"
          cy="698.363"
          r="296.375"
          transform="rotate(-33.0533 728.468 698.363)"
          fill="#FF824D"
        />
      </g>

      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
          opacity={0.9}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
